import './Principal.css';
import HeaderPrincipal from './HeaderPrincipal';

function Principal({num}){


    return(
        <main className='main-principal-sd'>

        <HeaderPrincipal cart={num}/>  

            <div className="relative overflow-hidden bg-white">

                
                
                <div className="pb-80 pt-16 sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
                    
                    <div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8">
                    
                    <div className="sm:max-w-lg">
                        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                        ShaBless <br /> Accesorios & Mas
                        </h1>
                        <p className="mt-4 text-xl text-gray-500">
                        Mi tienda de accesorios es el lugar perfecto para aquellos que buscan complementar su estilo personal con productos únicos y de calidad. Ofrecemos una amplia variedad de accesorios, desde joyería, bolsos, sombreros, relojes, carteras y mucho más.
                        </p>
                    </div>
                    <div>
                        <div className="mt-10">
                        {/* Decorative image grid */}
                        <div
                            aria-hidden="true"
                            className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
                        >
                            <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                            <div className="flex items-center space-x-6 lg:space-x-8">
                                <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                <div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                                    <img
                                    src="https://img.ltwebstatic.com/images3_pi/2023/01/29/1674959605ddea3a8126e1b12ba3c0ca89168c33cf_thumbnail_810x.webp"
                                    alt=""
                                    className="h-full w-full object-cover object-center"
                                    />
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img
                                    src="https://img.ltwebstatic.com/images3_pi/2023/08/27/2c/16931518314012890a42691a148a26e064a096fbc1_thumbnail_220x293.jpg"
                                    alt=""
                                    className="h-full w-full object-cover object-center"
                                    />
                                </div>
                                </div>
                                <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img
                                    src="//img.ltwebstatic.com/images3_pi/2022/09/30/16645077237dc09c5a90a367f2970c962d7cb474f5_thumbnail_220x293.jpg"
                                    alt=""
                                    className="h-full w-full object-cover object-center"
                                    />
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img
                                    src="//img.ltwebstatic.com/images3_spmp/2023/08/30/0e/16933869588b2edb1779fe871f0c044a591a0faf55_thumbnail_220x293.jpg"
                                    alt=""
                                    className="h-full w-full object-cover object-center"
                                    />
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img
                                    src="//img.ltwebstatic.com/images3_pi/2021/07/02/1625214818c37393e475306b063fcd3f7ab8bf5a9e_thumbnail_220x293.jpg"
                                    alt=""
                                    className="h-full w-full object-cover object-center"
                                    />
                                </div>
                                </div>
                                <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img
                                    src="//img.ltwebstatic.com/images3_spmp/2023/06/10/168636752412b29f5ed9b6b10c1540d3716a0ced0b_thumbnail_220x293.jpg"
                                    alt=""
                                    className="h-full w-full object-cover object-center"
                                    />
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img
                                    src="//img.ltwebstatic.com/images3_pi/2022/11/01/166726676639830d75ea8131f12471e6508ccb2fec_thumbnail_220x293.jpg"
                                    alt=""
                                    className="h-full w-full object-cover object-center"
                                    />
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>

                        <a
                            href="#"
                            className="inline-block rounded-md border border-transparent bg-[#fb8cff] px-8 py-3 text-center font-medium text-white hover:bg-[#f66efb]"
                        >
                            Ir a comprar
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
            </div>


        </main>
    )
}

export default Principal;
